import React, {useEffect, useState} from 'react';
import './scss/asset-view.scss';
import StatusView from "./status-view";
import Layout from "./layout";
import AssetView from "./asset-view";
import AssetExtend from "./asset-extend";
import SandraJsAPI from "../services/sandraJsAPI";
import FullScreenLoader from "./full-screen";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function Asset(): React.ReactElement {

    const urlParams = new URLSearchParams(window.location.search);
    const assetId = String(urlParams.get('id') || "");

    const [statusMessage, setStatusMessage] = useState({message: '', type: StatusMessageTypeEnum.none});
    const [extendedAsset, setExtendedAsset] = useState("");
    const [assetIdText, setAssetIdText] = useState(assetId);
    const [dbConfig, setDBConfig] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const onStatusMessage = (message: string, type: StatusMessageTypeEnum) => {
        setStatusMessage({message, type});
    };
    const onAssetLoaded = (id: string, data: any) => {
        setAssetIdText(id);
        setExtendedAsset(JSON.stringify(data));
    };

    useEffect(() => {
        setIsLoading(true);
        onStatusMessage("", StatusMessageTypeEnum.none);
        SandraJsAPI.getRequestDBConfig().then(res => {
            if (res.error?.status) {
                onStatusMessage(res.error.message, StatusMessageTypeEnum.error);
            }
            setDBConfig(JSON.stringify(res.data));
            setIsLoading(false);
        }).catch(error => {
            onStatusMessage(error.message, StatusMessageTypeEnum.error);
            setIsLoading(false);
        })
    }, []);

    return (
        <Layout className="page asset  loading-wrapper">
            <StatusView status={statusMessage}/>
            {isLoading ? <FullScreenLoader/> : <div/>}
            <div className="normal-text-italic">
                <p className="text-sm-label m-2 mb-0"><strong className="pe-1">Sandra DB Config:</strong>
                    <span>{dbConfig}</span>
                </p>
                <div className="row">
                    <div className="col-md-6">
                        <AssetView setStatusMessage={onStatusMessage} assetId={assetIdText}
                                   onLoaded={onAssetLoaded}/>
                    </div>
                    <div className="col-md-6">
                        <AssetExtend assetId={assetIdText} extendedAsset={extendedAsset}
                                     setStatusMessage={onStatusMessage}/>
                    </div>
                </div>
            </div>
        </Layout>
    );

}

export default Asset;
